module.exports = __webpack_public_path__ + "img/bambu-logo.f087d2c6.jpeg";